import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments';
import { NCList } from './nonconformities-api.model';
import { mapToHttpParams } from '@bcl/common-ui';
import * as dto from './nonconformities-api.model';

@Injectable({ providedIn: 'root' })
export class NCsApiService {
  private parentContext?: dto.ParentContext;
  private baseUrl = `${environment.apiHost}/mobile`;
  constructor(private http: HttpClient) {}

  public getParentNCs(
    filters: dto.GetParentNCsFilter,
    pageNumber: number,
    pageSize: number
  ): Observable<NCList> {
    return this.http.get<NCList>(`${this.baseUrl}/nonconformity/list`, {
      params: mapToHttpParams({ ...filters, pageNumber, pageSize }),
    });
  }

  public setParentContext(parentContext: dto.ParentContext): void {
    this.parentContext = parentContext;
  }
}
